import { render, staticRenderFns } from "./announcement-dialog.vue?vue&type=template&id=e0ade54c&scoped=true"
import script from "./announcement-dialog.vue?vue&type=script&lang=js"
export * from "./announcement-dialog.vue?vue&type=script&lang=js"
import style0 from "./announcement-dialog.vue?vue&type=style&index=0&id=e0ade54c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0ade54c",
  null
  
)

export default component.exports